<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.store', 2) }}
          <v-btn color="primary" @click="goTo('newStore')"> {{ $t('create') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :items="items"
                      :loading="loading"
                      hide-headers
                      hide-actions
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.id }} </td>
            <td>
              <img :src="providerImg(props.item.provider)" :alt="props.item.provider" :width="imgWidth(props.item.provider)" />
            </td>
            <td> {{ props.item.params.shop }} </td>
            <td>
              <v-btn color="primary" v-if="isTiendaNube(props.item)" flat icon @click="loginTiendaNube(props.item.id)">
                <font-awesome-icon icon="download"></font-awesome-icon>
              </v-btn>
            </td>
            <td class="pa-0 pr-2 text-xs-right">
              <v-btn color="red" flat icon @click="destroy(props.item)">
                <font-awesome-icon icon="times"></font-awesome-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Store from '@/client/store'

export default {
  name: 'StoresView',

  props: {},

  data () {
    return {
      items: [],
      loading: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    providerImg (source) {
      const imgs = {
        'shopify': '/shopify-logo.png',
        'woocommerce': '/woocommerce-logo.png'
      }
      return imgs[source]
    },

    isTiendaNube (item) {
      let provider  = item.provider;
      let code  = item.params["code"];
      let access_token  = item.params["access_token"];
      let parameters = this.$route.query;
      return (provider == 'tiendanube' && parameters["code"] == undefined) &&
             (code == "" || access_token == "")
    },

    loginTiendaNube(store_id){
      window.location.href = `https://www.tiendanube.com/apps/6324/authorize?state=${store_id}`
    },

    imgWidth (source) {
      const src = this.providerImg(source)
      const img = new Image()
      img.src = src
      if (img.naturalHeight > img.naturalWidth) {
        return 20
      }
      return 50
    },

    async fetch () {
      this.loading = true
      this.items = await Store.all()
      this.loading = false
    },

    async savetiendacode(){
      var parameters = this.$route.query;
      if(parameters["code"] != undefined && parameters["state"] != undefined){
        await Store.saveCodeTiendaNube(parameters["state"], parameters["code"])        
      }
    },

    async destroy (store) {
      try {
        await Store.destroyById(store.id)
      } catch (err) {
        // empty
      }
      this.fetch()
    }
  },

  watch: {
  },

  async mounted () {
    this.fetch()
    this.savetiendacode()
  }
}
</script>
